// "Listen" button for AI narratives — plays the text via backend TTS. Renders nothing
// when agent voice is disabled (Features:AgentVoice off, e.g. Production) or there is
// no text. Styled to sit beside the narrative CopyButton.
import React from 'react';
import { Volume2, Square, Loader2 } from 'lucide-react';
import { useAgentVoice } from '../../contexts/FeatureFlagsContext';
import { useTextToSpeech } from '../../hooks/useTextToSpeech';

const ListenButton = ({ text }) => {
  const enabled = useAgentVoice();
  const { status, play, stop, prefetch } = useTextToSpeech();

  if (!enabled || !text) return null;

  const idle = status === 'idle';
  return (
    <button
      onClick={() => (idle ? play(text) : stop())}
      onMouseEnter={() => prefetch(text)}
      className="flex items-center gap-1 text-xs text-gray-400 hover:text-gray-700 transition-colors px-2 py-1 rounded hover:bg-gray-100"
      title={idle ? 'Listen to this briefing' : 'Stop'}
    >
      {status === 'loading' ? (
        <Loader2 className="h-3.5 w-3.5 animate-spin" />
      ) : status === 'playing' ? (
        <Square className="h-3.5 w-3.5" />
      ) : (
        <Volume2 className="h-3.5 w-3.5" />
      )}
      {idle ? 'Listen' : 'Stop'}
    </button>
  );
};

export default ListenButton;
